import React from 'react';
import { Page } from '../Page';
import { Shield, Heart, Bone } from 'lucide-react';
export function SupplementMultiVitamin() {
  return <Page pageNumber={14} variant="light" data-id="element-3233">
      <div className="flex flex-col h-full" data-id="element-3234">
        <div className="mb-6 pt-4" data-id="element-3235">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3236">
            Supplement Spotlight
          </p>
          <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3237">
            Daily Multi-Vitamin
          </h1>
          <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3238">
            Fill the nutrient gaps that come with eating less
          </p>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-3239" />
        </div>

        <div className="mb-8" data-id="element-3240">
          <h2 className="text-sm font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3241">
            Why It Matters on GLP-1
          </h2>
          <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-3242">
            GLP-1 medications reduce appetite and caloric intake, which
            increases the risk of micronutrient gaps. A comprehensive multi
            fills those gaps as "dietary insurance," especially important when
            eating less food overall. Thorne's multis use highly bioavailable
            forms without unnecessary additives, maximizing absorption even with
            smaller meals.
          </p>
        </div>

        {/* 3 Bottles Row */}
        <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-3243">
          <div className="flex flex-col items-center" data-id="element-3244">
            <img src="https://cdn.magicpatterns.com/uploads/cVkBKeTkhs1FfSNaZuZQaq/pasted-image.png" alt="Basic Nutrients 2/Day" className="h-40 object-contain mb-4" data-id="element-3245" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3246">
              Basic Nutrients 2/Day
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3247">
              All Adults
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3248">
            <img src="https://cdn.magicpatterns.com/uploads/oATeeYw3b3m4kzEqAuzdQa/pasted-image.png" alt="Men's Multi 50+" className="h-40 object-contain mb-4" data-id="element-3249" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3250">
              Men's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3251">
              Men 50+
            </p>
          </div>
          <div className="flex flex-col items-center" data-id="element-3252">
            <img src="https://cdn.magicpatterns.com/uploads/9fk743VWayU2KFEujmpVDA/pasted-image.png" alt="Women's Multi 50+" className="h-40 object-contain mb-4" data-id="element-3253" />
            <h3 className="text-sm font-bold text-[#1F1F1F] text-center mb-1" data-id="element-3254">
              Women's Multi 50+
            </h3>
            <p className="text-[10px] text-[#7A7A70] text-center uppercase tracking-wider" data-id="element-3255">
              Women 50+
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-3256">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3257">
            <Shield className="w-5 h-5 text-tealslate mb-3" data-id="element-3258" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3259">
              Simplified daily coverage. Includes chromium for blood sugar
              support and highly absorbable zinc bisglycinate.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3260">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3261">2 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3262">60 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3263">
            <Heart className="w-5 h-5 text-tealslate mb-3" data-id="element-3264" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3265">
              Prostate and heart focus. Includes lycopene and zinc for prostate
              health, plus magnesium for muscle support.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3266">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3267">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3268">180 caps per bottle</p>
            </div>
          </div>

          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex flex-col" data-id="element-3269">
            <Bone className="w-5 h-5 text-tealslate mb-3" data-id="element-3270" />
            <p className="text-xs text-[#3B3B3B] leading-[1.6] mb-4 flex-1" data-id="element-3271">
              Bone support focus. Includes Vitamins D3 and K2. Iron-free formula
              designed for postmenopausal women.
            </p>
            <div className="border-t border-[#D8D8D0] pt-3 mt-auto" data-id="element-3272">
              <p className="text-[11px] font-bold text-[#1F1F1F]" data-id="element-3273">6 caps/day</p>
              <p className="text-[10px] text-[#7A7A70]" data-id="element-3274">180 caps per bottle</p>
            </div>
          </div>
        </div>

        <div className="mt-auto flex items-center gap-3" data-id="element-3275">
          <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3276" />
          <div data-id="element-3277">
            <p className="text-xs font-bold text-[#1F1F1F]" data-id="element-3278">Choose Your Fit</p>
            <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3279">
              If you're interested in a supplement plan tailored to you, check
              out the link below! Fullscript provides third-party tested, safe
              and effective supplements to help get your health where you want
              it at wholesale prices.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}